import AuthView from '../views/auth';

module.exports = function () {
  return new AuthView();
};



// WEBPACK FOOTER //
// ./parentpay/initializers/auth.js